import { render, staticRenderFns } from "./BerufsgruppeWahlField.vue?vue&type=template&id=8e03999c&scoped=true&"
import script from "./BerufsgruppeWahlField.vue?vue&type=script&lang=js&"
export * from "./BerufsgruppeWahlField.vue?vue&type=script&lang=js&"
import style0 from "./BerufsgruppeWahlField.vue?vue&type=style&index=0&id=8e03999c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e03999c",
  null
  
)

export default component.exports